<script>
    import { onDestroy, onMount } from "svelte";

    import {
        Button,
        PageLoading,
        LoadingModal,
        NotificationModal,
        BackArrow,
    } from "../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import ChangeDoctorSection from "./createEditSections/ChangeDoctorSection.svelte";
    import PatientDetailsSection from "./createEditSections/PatientDetailsSection.svelte";
    import PatientContactSection from "./createEditSections/PatientContactSection.svelte";
    import ProcedureDetailsSection from "./createEditSections/ProcedureDetailsSection.svelte";
    import InsuranceDetailsSection from "./createEditSections/InsuranceDetailsSection.svelte";

    import {
        goBack,
        setInputFilter,
        goToURL,
        showError,
        showException,
        isObjectEmpty,
        areObjectEqual,
        resetPreventRedirectProperty,
        backToList,
        splitCamelCase,
        showConfirmAction,
        getFormatDate,
        isSameDate,
        toLocalDateString,
        showInfo,
    } from "../../../Utils/utilFunctions.svelte";

    import {
        loggedInDoctorDetail,
        insuranceFund,
        accountDoctors,
        user,
        preventRedirect,
        preventRedirectObj,
        EncounterSidePanelProps,
    } from "../../../stores";

    import {
        DirectInsuranceType,
        DirectUserRoles,
        defaultState,
    } from "../../../Utils/utilEnums.svelte";

    import { getDAN, getPID } from "../../../Utils/DataSyncFunctions.svelte";

    import {
        checkPatientDetailsChange,
        checkPatientOpvFail,
        getMatchedSurgeon,
        resetIrrelevantInsuranceDetails,
        syncEncounterSpecialInsuranceObj,
        syncInsuranceDetailsOfLatestBillingData,
        syncLabourEpiduralPatientTitleAndGender,
        syncPatientInsuranceDetails,
        updatedBillingStatus,
    } from "../helpers/encounterHelper.svelte";

    import {
        addErrorInput,
        removeErrorInput,
    } from "../helpers/encounterUtils.svelte";

    import { insuranceTypeHideQuoteSections } from "../../../Utils/utilConstants.svelte";
    import CardLayout from "../../../Components/Common/CardLayout.svelte";
    import PreOpDetailsSection from "./createEditSections/PreOpDetailsSection.svelte";
    import OtherDetailsSection from "./createEditSections/OtherDetailsSection.svelte";

    export let isEditDuplicate, isDuplicateFromTable;

    export let isViewInDailyCalendarSidePanel,
        calendarSidePanelProps = {};

    export let patientEncounterId;

    export let updatePatientDetails = () => {};

    export let updatePatientEncounterDetails = () => {};

    export let fromSidePanel = false; // currently archived
    export let isFromCalendarList = false;

    let isLoadingDoctor = false,
        isLoadingPatientEncounterDetails = false,
        isUpdatingPatientEncounter = false,
        patientDetails = {},
        __BACKUP__PATIENT__DETAILS = {},
        patientEncounterDetails = {},
        __BACKUP__ENCOUNTER__ = {},
        selectedDoctorProvider = {},
        insuranceDetails = {},
        selectedSurgeon = {},
        __BACKUP__SELECTED__SURGEON__ = {},
        selectedHospital = {},
        __BACKUP__SELECTED__HOSPITAL__ = {},
        createSurgeonFilters = { state: defaultState };

    let isPatientMatched = true;

    let patientContactDetails = { useAsContact: false },
        patientContactsArr = [];

    let showSaveWithoutValidations = false;

    let workerCompensation,
        workerCompensationObj = {};

    let defenceDataObj = {};

    let trafficAuthority,
        trafficAuthorityObj = {};

    let publicInPrivateObj = {};

    let thirdPartyPayerObj = {};

    let errorFields = [];

    let isOpvSuggestionsAttempt = false,
        isShowConfirmModalAfterAttempt = false;

    let isCheckingOPV = false,
        opvResponse = {},
        isOpvFailedModalOpen = false;

    let patientSectionRef,
        patientContactRef,
        procedureDetailsRef,
        insuranceDetailsRef,
        surgeonDetailsRef;

    let isEncounterEnablePartiallyEditOnly = false,
        lockInputNotificationMsg = "",
        isEncounterHasActiveEstimate = false,
        isEncounterHasActiveInvoice = false,
        // encounter status is 1 or 2 && has valid quote
        disableInputScenario_ONE = false,
        // encounter status is 3, 4 or 5
        disableInputScenario_TWO = false,
        oldInsuranceType,
        // Sum the amount of (payments received (status 1) and received externally (status 2) - payments processing fee) - amount of (payments refunded (status 5))
        totalSumOfPayments = 0;

    let unlockAllInputsModalOpen = false,
        UNLOCK_ALL_INPUTS = false;

    let keyInsuranceDetailsEdited = false,
        showKeyInsuranceEditedModal = false;
    let oldScheduledDate; //keeps the ols schedule date in case user will change it

    // if set TRUE then no validation check on submission
    let overrideValidation = false;

    $: isLoading = isLoadingDoctor || isLoadingPatientEncounterDetails;

    $: isFlowEnableSearchDoctor =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    $: if (patientDetails.insuranceType == 15) {
        const patientMedicareNoField = document.getElementById(
            "patientMedicareNoField",
        );
        const patientMedicareRefNoField = document.getElementById(
            "patientMedicareRefNoField",
        );
        if (patientMedicareNoField) {
            patientMedicareNoField.style.outline = "";
            patientMedicareNoField.placeholder = "Medicare No.";
        }
        if (patientMedicareRefNoField) {
            patientMedicareRefNoField.style.outline = "";
            patientMedicareRefNoField.placeholder = "Medicare Ref No.";
        }
    } else updateInputFields();

    $: enableChangeEncounterDoctor =
        isEditDuplicate &&
        [
            DirectUserRoles.Admin,
            DirectUserRoles.Manager,
            DirectUserRoles.Support,
        ].includes($user.role);

    $: isEncounterUnsaved = _watchUnsavedDetails(
        patientEncounterDetails,
        __BACKUP__ENCOUNTER__,
        patientDetails,
        __BACKUP__PATIENT__DETAILS,
        selectedSurgeon,
        __BACKUP__SELECTED__SURGEON__,
        selectedHospital,
        __BACKUP__SELECTED__HOSPITAL__,
    );

    $: hasPatientDetailsChanged = checkPatientDetailsChange(
        __BACKUP__PATIENT__DETAILS,
        patientDetails,
    );

    $: $preventRedirect = isEncounterUnsaved && !fromSidePanel;

    $: if ($preventRedirect) updatePreventRedirectObj();
    else resetPreventRedirectProperty();

    onMount(async () => {
        if (isFlowEnableSearchDoctor) {
            $accountDoctors = [];
        }

        if (patientEncounterId)
            await loadPatientEncounterDetails(patientEncounterId);

        await loadDoctor(patientEncounterDetails.doctor.id);

        setTimeout(() => {
            updateInputFields();
        }, 1000);
    });

    onDestroy(() => {
        if (isFlowEnableSearchDoctor) {
            $loggedInDoctorDetail = {};
            $accountDoctors = [];
        }
    });

    const loadPatientEncounterDetails = async (patientEncounterId) => {
        isLoadingPatientEncounterDetails = true;

        await apiMethods.getMethod
            .getPatientEncounterById(patientEncounterId)
            .then((res) => {
                if (res.id == patientEncounterId)
                    _syncPatientEncounterDetails(res);
            })
            .catch((err) => showException(err));

        syncPartialEditableProperties(patientEncounterDetails);

        isLoadingPatientEncounterDetails = false;
    };

    const loadDoctor = async (id) => {
        isLoadingDoctor = true;

        // each time when trigger this function means doctor changes, thus reset these two
        $loggedInDoctorDetail = {};

        await apiMethods.getMethod
            .getAccountById(id)
            .then((res) => {
                if (res.id) $loggedInDoctorDetail = { ...res };
            })
            .then(() => (isLoadingDoctor = false));
    };

    const updateInputFields = () => {
        setInputFilter(
            document.getElementById("patientMedicareNoField"),
            function (value) {
                return value ? /^[0-9-\s]+$/i.test(value) : true;
            },
            "Must be an integer",
        );

        setInputFilter(
            document.getElementById("patientMedicareRefNoField"),
            function (value) {
                return value ? /^[0-9]+$/.test(value) : true;
            },
            "Must be an integer",
        );

        setInputFilter(
            document.getElementById("insuranceDetailsMembershipNoField"),
            function (value) {
                return value ? /^[A-z0-9]+$/.test(value) : true;
            },
            "Must be either an integer or a character",
        );

        setInputFilter(
            document.getElementById("insuranceDetailsMembershipRefNoField"),
            function (value) {
                return value ? /^[0-9]+$/.test(value) : true;
            },
            "Must be an integer",
        );
    };

    const handleUpdateEncounter = async () => {
        //check if encounter has quote sent, and schedule date was sent
        var oldDate = new Date(oldScheduledDate);
        var newDate = new Date(patientEncounterDetails.scheduledDate);
        if(patientEncounterDetails && !patientEncounterDetails.quoteOnly && 
            !isSameDate(oldDate, newDate) &&    
            patientEncounterDetails.estimates.length > 0 && 
            patientEncounterDetails.estimates.some((e) => e.status != 9)) {

            var estimate = patientEncounterDetails.estimates.find(e => e.status != 9);
            //determine if to keep the old date or update is needed
            var shouldUpdateDueDate = true;
            if(estimate && estimate.payments.length > 0) {
                //estimate has payments, check if fully paid
                if(patientEncounterDetails.patientPaymentTag == 5) {
                    //fully paid
                    shouldUpdateDueDate = false;
                }
            }

            if(shouldUpdateDueDate){
                const keepTheOldDate =
                    new Date(patientEncounterDetails.scheduledDate) < new Date(oldScheduledDate) &&
                    new Date(patientEncounterDetails.scheduledDate) > new Date(estimate.expireDate);
                showConfirmAction({
                    modalMaxWidth: "max-w-2xl",
                    title: "Action required",
                    message: `A quote was sent with ${getFormatDate(estimate.expireDate)} as due date. Updating the procedure date can have a significant impact on the due date of this quote.`,
                    actions: [
                        {
                            title: keepTheOldDate
                                    ? "Keep due date"
                                    : "Update due date",
                            onClick: async () => {
                                //update due date
                                if(keepTheOldDate) {
                                    //do nothing, continue with updating the encounter
                                    await updatePatient();
                                } else {
                                    //update due date
                                    await updateExistingQuoteDueDate(patientEncounterDetails.scheduledDate, estimate);
                                    //continue with updating the encounter
                                    await updatePatient();
                                }
                            }
                        },
                        {
                            title: "Cancel Quote",
                            onClick: async () => {
                                //cancel quote
                                await apiMethods.putMethod
                                    .updateEstimateStatus(estimate.id, 9)
                                    .then(async (res) => {
                                        if (res.error) showError(res.error);
                                        else {
                                            //continue with updating the encounter
                                            if(patientEncounterDetails.billingStatus == 1) {
                                                //quoted, move to pre-quote
                                                patientEncounterDetails.billingStatus = 0;
                                            }
                                              
                                            await updatePatient();
                                        }
                                    })
                                    .catch((err) => showException(err));
                            }
                        }
                    ]
                })
            }
            
        } else {
           await updatePatient();
        }
       
    };

    const updateExistingQuoteDueDate = async (newScheduleDate, estimate) => {
        //get estimate billing data
        var quoteData = patientEncounterDetails.billingData.find(b => b.id == estimate.patientEncounterBillingDataId);
        if(quoteData && quoteData.customDueDate) {
            var currentDueDate = new Date(quoteData.customDueDate);
            //get days difference in days
            const daysDiff = Math.floor(
                (new Date(newScheduleDate) - new Date(currentDueDate)) / (1000 * 60 * 60 * 24)
            );
            //determine new due date
            var newDueDate = new Date(currentDueDate);
            newDueDate.setDate(newDueDate.getDate() + daysDiff);
            //if new due date is in the past set it to today
            if (newDueDate < new Date()) {
                newDueDate = new Date();
            }

            //update custom due date on billing data
            patientEncounterDetails.billingData =
                patientEncounterDetails.billingData.map((bd) => {
                    if (bd.id == quoteData.id) return { ...bd, customDueDate: toLocalDateString(newDueDate) };
                    return bd;
                });

            //update estimate expiredDate, set only the date, ignore the time
            estimate.expireDate = toLocalDateString(newDueDate);
            await apiMethods.putMethod
                .updateEstimate(estimate)
                .then((res) => {
                    if (!res || res.error)
                        showError(
                            res.error ??
                                "Failed to update quote details, please refresh the page and try again and contact support if the issue persists.",
                        );
                    else {
                        showInfo("Quote due date was updated successfully");
                    }
                })
                .catch((err) => showError(err));
        }
    }

    const handleUnlockAllInputs = () => {
        _closeUnlockAllInputsModal();
        UNLOCK_ALL_INPUTS = true;
    };

    const removeIrrelevantInsuranceDetails = () => {
        const cleanUpDataObj = resetIrrelevantInsuranceDetails(
            patientDetails,
            insuranceDetails,
            workerCompensation,
            workerCompensationObj,
            trafficAuthority,
            trafficAuthorityObj,
            publicInPrivateObj,
            thirdPartyPayerObj,
            defenceDataObj
        );

        patientDetails = cleanUpDataObj.patientDetails;
        insuranceDetails = cleanUpDataObj.insuranceDetails;
        workerCompensation = cleanUpDataObj.wcData;
        workerCompensationObj = cleanUpDataObj.wcObj;
        trafficAuthority = cleanUpDataObj.tacData;
        trafficAuthorityObj = cleanUpDataObj.tacObj;
        publicInPrivateObj = cleanUpDataObj.pipObj;
        thirdPartyPayerObj = cleanUpDataObj.tppObj;
        defenceDataObj = cleanUpDataObj.defObj;
    };

    const updatePatient = async () => {
        if (await _checkInputFieldsValid()) {
            isUpdatingPatientEncounter = true;

            if (
                patientDetails.medicareRefNo ||
                patientDetails.medicareRefNo == 0
            )
                patientDetails.medicareRefNo = Number(
                    patientDetails.medicareRefNo,
                );
            else patientDetails.medicareRefNo = null;

            _updatePatientInsuranceDetails();

            if (patientDetails.title == "Title") patientDetails.title = 20;

            if (patientDetails.insuranceType == 20)
                patientDetails.insurance = "";

            // format schedule date and time
            if (!patientEncounterDetails.scheduledTime)
                patientEncounterDetails.scheduledTime = "00:00:00";
            else if (
                patientEncounterDetails.scheduledTime.split(":").length < 3
            )
                patientEncounterDetails.scheduledTime += ":00";

            patientEncounterDetails.scheduledDate =
                patientEncounterDetails.scheduledDate
                    ? patientEncounterDetails.scheduledDate.split("T")[0] +
                      "T" +
                      patientEncounterDetails.scheduledTime
                    : null;

            // format discharge date and time
            if (!patientEncounterDetails.dischargeTime)
                patientEncounterDetails.dischargeTime = "00:00:00";
            else if (
                patientEncounterDetails.dischargeTime.split(":").length < 3
            )
                patientEncounterDetails.dischargeTime += ":00";

            patientEncounterDetails.dischargeDate =
                patientEncounterDetails.dischargeDate
                    ? patientEncounterDetails.dischargeDate.split("T")[0] +
                      "T" +
                      patientEncounterDetails.dischargeTime
                    : null;

            if (
                (patientEncounterDetails.estimates?.length ||
                    patientEncounterDetails.invoices?.length) &&
                (patientDetails.insuranceId !=
                    __BACKUP__PATIENT__DETAILS.insuranceId ||
                    patientDetails.insurance !=
                        __BACKUP__PATIENT__DETAILS.insurance ||
                    patientDetails.insuranceType !=
                        __BACKUP__PATIENT__DETAILS.insuranceType)
            )
                keyInsuranceDetailsEdited = true;

            // if (!isEditDuplicate) await updateProcess(patientDetails);
            // else await checkPatientProcess(patientDetails);

            // create new patient if change selected doctor and failed matching patient
            if (!isPatientMatched) await createProcess(patientDetails);
            else await updateProcess(patientDetails);

            isUpdatingPatientEncounter = false;
        }
        else {
            showSaveWithoutValidations = true;
        }
    };

    const updateProcess = async (pd) => {
        let isPatientUpdated = false;

        await apiMethods.putMethod
            .updatePatient(pd)
            .then(async (res) => {
                if (res.id) {
                    _updatePatientEncounterDetails(res);
                    isPatientUpdated = true;
                } else showError(res.error);
            })
            .catch((err) => showException(err));

        if (isPatientUpdated) {
            if (isEditDuplicate) await createPatientEncounter();
            else await updatePatientEncounter();
        }
    };

    const updatePatientEncounter = async () => {
        await apiMethods.putMethod
            .updatePatientEncounter(patientEncounterDetails, false, "Update encounter (edit)")
            .then((res) => {
                if (res.id) {
                    updatePatientDetails(patientDetails);
                    updatePatientEncounterDetails(res);
                } else showError(res.error);
            })
            .catch((err) => showException(err));

        isUpdatingPatientEncounter = false;

        if (keyInsuranceDetailsEdited)
            return (showKeyInsuranceEditedModal = true);

        if (isViewInDailyCalendarSidePanel)
            calendarSidePanelProps.afterSaveEncounter();
        else if (isFromCalendarList) {
            $EncounterSidePanelProps.shouldTriggerCloseFunction = true;
            $EncounterSidePanelProps.type = "view";
        } else goBack();
    };

    const closesKeyInsuranceEditedModal = () => {
        resetPreventRedirectProperty();
        if (isViewInDailyCalendarSidePanel)
            calendarSidePanelProps.afterSaveEncounter();
        else goBack();
        showKeyInsuranceEditedModal = false;
    };

    const checkPatientProcess = async (pd) => {
        if (!pd.medicareNo) pd.medicareNo = "";
        if (!pd.membershipNo) pd.membershipNo = "";

        // check !delete patient by first & middle & last name && dob && medicareNo
        await apiMethods.postMethod
            .matchPatient(pd, $loggedInDoctorDetail.id)
            .then(async (res) => {
                if (res.id) {
                    _updatePatientEncounterDetails(res);
                    createPatientEncounter();
                } else await createProcess(pd);
            })
            .catch((err) => showError(err));
        // await createProcess(pd);
    };

    const createProcess = async (pd) => {
        let isPatientCreated = false;

        await apiMethods.postMethod
            .createPatient(pd)
            .then((res) => {
                if (res.id) {
                    _updatePatientEncounterDetails(res);
                    isPatientCreated = true;
                }
            })
            .catch((err) => showException(err));

        if (isPatientCreated) {
            if (isEditDuplicate) await createPatientEncounter();
            else await updatePatientEncounter();
        }
    };

    const createPatientEncounter = () => {
        const encounterObj = {
            ...patientEncounterDetails,
            billingData: [],
            estimates: [],
            invoices: [],
            skipQuote: false,
            billingStatus: 0,
        };

        let copyPreOpAnswersFromEncounterId = 0;

        //for duplicate, if it has questionnaire sent and answered, copy also answers
        if(encounterObj.preOpQuestionnaireId && encounterObj.hasPreOpQuestionnaireSent && encounterObj.hasPreOpQuestionnaireAnswers) {
            copyPreOpAnswersFromEncounterId = encounterObj.id;
        }

        delete encounterObj.id;

        apiMethods.postMethod
            .createPatientEncounter(encounterObj)
            .then(async (res) => {
                if (res.id) {

                    //need to copy answers?
                    if(copyPreOpAnswersFromEncounterId) {
                         await apiMethods.putMethod
                            .copyPreOpQuestionnaire(
                                copyPreOpAnswersFromEncounterId,
                                res.id,
                            )
                            .then(async (copyRes) => {
                                if (!copyRes || copyRes.error)
                                    showError("Failed to copy Pre-Op Questionnaire answer to this encounter, but encounter was duplicated");
                            });
                    }

                    if (isViewInDailyCalendarSidePanel)
                        calendarSidePanelProps.afterSaveEncounter();
                    else if (isFromCalendarList) {
                        $EncounterSidePanelProps.shouldTriggerCloseFunction = true;
                        $EncounterSidePanelProps.id = res.id;
                        $EncounterSidePanelProps.type = "view";
                    } else goToURL(`/PatientEncounter/view/${res.id}`);
                }
            })
            .catch((err) => showException(err));
    };

    const closeConfirmModalAfterAttempt = () => {
        isShowConfirmModalAfterAttempt = false;
        isUpdatingPatientEncounter = false;
        isOpvSuggestionsAttempt = false;
    };

    const syncPartialEditableProperties = (encounter) => {
        const { billingStatus, estimates, invoices, typeOfBill } = encounter;

        const { insuranceType } = patientDetails;

        isEncounterHasActiveEstimate =
            _checkIfEncounterHasActiveEstimateOrInvoice(estimates);

        isEncounterHasActiveInvoice =
            _checkIfEncounterHasActiveEstimateOrInvoice(invoices);

        // Unlock all fields for Ready encounters which quote-related sections are hidden and no active invoices
        const specialCase_ONE =
            billingStatus == 2 &&
            !isEncounterHasActiveInvoice &&
            (typeOfBill == 2 ||
                insuranceTypeHideQuoteSections.includes(insuranceType));

        if (specialCase_ONE) {
            disableInputScenario_ONE = false;
            disableInputScenario_TWO = false;
            isEncounterEnablePartiallyEditOnly = false;
            return;
        }

        if (isEncounterHasActiveEstimate)
            totalSumOfPayments += _sumPayments(estimates);

        if (isEncounterHasActiveInvoice)
            totalSumOfPayments += _sumPayments(invoices);

        lockInputNotificationMsg = _syncNotificationMsg(
            billingStatus,
            isEncounterHasActiveEstimate,
            isEncounterHasActiveInvoice,
        );

        if (
            // isEncounterHasActiveEstimate &&
            billingStatus == 1 ||
            billingStatus == 2
        )
            disableInputScenario_ONE = true;

        if (billingStatus == 3 || billingStatus == 4 || billingStatus == 5) {
            if (isEncounterHasActiveInvoice) disableInputScenario_ONE = true;
            disableInputScenario_TWO = true;
        }

        isEncounterEnablePartiallyEditOnly =
            _checkIfEncounterEnablePartiallyEditOnly(estimates, invoices) ||
            disableInputScenario_ONE ||
            disableInputScenario_TWO;
    };

    const patientOpvCheck = async () => {
        isCheckingOPV = true;

        opvResponse = {};

        await apiMethods.postMethod
            .checkOPV(patientDetails, true)
            .then(async (res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to check opv, please refresh the page and try again and contact support if the issue persists.",
                    );
                else {
                    let opvFailed = await checkPatientOpvFail(res);
                    if (opvFailed) {
                        opvResponse = { ...res };
                        _openOpvFailedModal();
                    } else await updatePatient();
                }
            })
            .catch((err) => showException(err));

        isCheckingOPV = false;
    };

    const showDotActionsMenu = () => {
        if (document.getElementById("encounterActionMenu"))
            document.getElementById("encounterActionMenu").style.display =
                "flex";
    };

    const hideDotActionsMenu = () => {
        if (document.getElementById("encounterActionMenu"))
            document.getElementById("encounterActionMenu").style.display =
                "none";
    };

    const updatePreventRedirectObj = () => {
        $preventRedirectObj = {
            message:
                "You have unsaved changes. Do you want to save before leaving this page?",
            btnOptions: [
                {
                    class: "btn-error",
                    text: "Discard changes",
                    ignoreFunction: true,
                    function: () => {
                        if (!isFromCalendarList) goBack();
                        else {
                            $EncounterSidePanelProps.type = "view";
                            $EncounterSidePanelProps.shouldTriggerCloseFunction = false;
                        }
                        resetPreventRedirectProperty();
                    },
                },
                {
                    text: "Save and continue",
                    hasBreakPoint: true,
                    function: async () => {
                        // await removeIrrelevantInsuranceDetails();

                        if (!(await _checkInputFieldsValid())) {
                            $preventRedirectObj.showModal = false;
                            return true;
                        }

                        await handleUpdateEncounter();

                        resetPreventRedirectProperty();
                    },
                },
            ],
        };
    };

    const onHospitalChange = ({ detail }) => {
        if (detail?.id) _syncProviderWithHospital(detail);
    };

    // HELPER FUNCTIONS
    const _syncProviderWithHospital = (hospital) => {
        const { id: hospitalId } = hospital;

        const doctorProvidersArr = $loggedInDoctorDetail.providers;

        if (!doctorProvidersArr.length) return;

        const relatedProvider = doctorProvidersArr.find(
            ({ hospitals }) =>
                hospitals &&
                hospitals.length &&
                hospitals.some((hospital) => hospital.hospitalId == hospitalId),
        );

        if (relatedProvider) {
            selectedDoctorProvider.details = { ...relatedProvider, selectLabel: `${relatedProvider.number}${relatedProvider.location ? ` (${relatedProvider.location})` : ""}` };
            if (
                relatedProvider.hospitals?.length &&
                patientDetails.insuranceType ==
                    DirectInsuranceType.PublicInPrivate
            ) {
                const pipHospital = relatedProvider.hospitals.find(
                    (h) => h.hospitalId == hospitalId,
                );
                if (pipHospital)
                    publicInPrivateObj.vendorNumbers =
                        pipHospital.pipVendorNumber ?? "";
            }
        } else {
            //no provider related to this hospital, set the default one
             var defaultOne = $loggedInDoctorDetail.providers.find((p) => p.isDefault);
            selectedDoctorProvider.details = { 
                ...defaultOne,
                selectLabel: `${defaultOne.number}${defaultOne.location ? ` (${defaultOne.location})` : ""}`
            };
        }
    };

    const _syncPatientEncounterDetails = (res) => {
        oldInsuranceType = res.patient.insuranceType;
        oldScheduledDate = res.scheduledDate;
        const {
            patient,
            doctorProvider,
            surgeon,
            hospital,
            patientEncounterWorkCoverData,
            patientEncounterThirdPartyInsurerData,
        } = res;

        patientEncounterDetails = {
            ...res,
            defaultBillingStatus: res.billingStatus,
        };

        patientDetails = syncPatientInsuranceDetails(patientEncounterDetails);

        // block of code auto change gender by patient title
        // if (
        //     (patientDetails.title == 0 || patientDetails.title == 20) &&
        //     patientDetails.sex == 2
        // )
        //     delete patientDetails.title;

        // if (patientDetails.title == 0 || patientDetails.title == 4)
        //     patientDetails.sex = 0;

        // if (
        //     patientDetails.title == 1 ||
        //     patientDetails.title == 2 ||
        //     patientDetails.title == 3
        // )
        //     patientDetails.sex = 1;

        // Merge patient insurance type from 0, 1, 2 to 0 (Private)
        if (
            patientDetails.insuranceType == 1 ||
            patientDetails.insuranceType == 2
        )
            patientDetails.insuranceType = 0;

        if (
            patientDetails.birthDate &&
            (new Date(patientDetails.birthDate).getFullYear() < 1900 ||
                new Date(patientDetails.birthDate) > new Date())
        )
            delete patientDetails.birthDate;

        // For Labour Epidural encounters, sync patient title and gender when encounter loaded
        patientDetails = syncLabourEpiduralPatientTitleAndGender(
            patientEncounterDetails,
            patientDetails,
        );

        // sync patientContact details
        const { patientContacts } = patientDetails;

        patientContactsArr = [...patientContacts];

        if (patientContacts.length) {
            if (patientContacts.some((contact) => contact.useAsContact))
                patientContactDetails = patientContacts.find(
                    (contact) => contact.useAsContact,
                );
            else patientContactDetails = patientContacts[0];
        }

        selectedDoctorProvider.details = doctorProvider
            ? { ...doctorProvider }
            : null;

        const matchSurgeon = getMatchedSurgeon(
            surgeon,
            hospital,
            doctorProvider,
            patientDetails,
        );

        selectedSurgeon.details = matchSurgeon ? { ...matchSurgeon } : null;

        selectedHospital.details = hospital ? { ...hospital } : null;

        if (!selectedHospital.details) selectedHospital.outsideHospital = true;
        else selectedHospital.outsideHospital = false;

        _updateScheduleDate(res.scheduledDate);

        _updateDischargeDate(res.dischargeDate);

        _syncInsuranceDetails(patient, patientEncounterWorkCoverData);

        if (isEditDuplicate) {
            // reset billing details if duplicate encounter
            patientEncounterDetails = {
                ...patientEncounterDetails,
                billingData: [],
                estimates: [],
                invoices: [],
                skipQuote: false,
                billingStatus: 0,
            };

            // Reset procedure details && surgeon details if duplicate from View Encounter
            // if (!isDuplicateFromTable) {
            //     selectedSurgeon = {};
            //     selectedHospital = {};
            //     patientEncounterDetails.procedureName = "";
            //     patientEncounterDetails.typeOfBill = Number(0);
            //     patientEncounterDetails.neuraxialType = Number(0);
            //     if (patientEncounterDetails.scheduledDate)
            //         delete patientEncounterDetails.scheduledDate;

            //     if (patientEncounterDetails.dischargeDate)
            //         delete patientEncounterDetails.dischargeDate;
            // }
        }

        __BACKUP__PATIENT__DETAILS = { ...patientDetails };
        if (patientDetails.birthDate)
            __BACKUP__PATIENT__DETAILS.birthDate =
                patientDetails.birthDate.split("T")[0];

        __BACKUP__ENCOUNTER__ = { ...patientEncounterDetails };

        __BACKUP__SELECTED__SURGEON__ = { ...selectedSurgeon };

        __BACKUP__SELECTED__HOSPITAL__ = { ...selectedHospital };
    };

    const defaultOverseasFund = {
                                    id: 0,
                                    name: "Other Overseas Insurance"
                                };

    const _syncInsuranceDetails = (patient, wcData) => {
        if (patientDetails.insuranceType == 0) {
            insuranceDetails.insuranceFund = $insuranceFund.find(
                (fund) => fund.id == patient.insuranceId,
            );
            insuranceDetails.membershipNo = patient.membershipNo;
            insuranceDetails.membershipRefNo = patient.membershipRefNo;

            insuranceDetails.privateCoverType = patient.insurance;
        } else if (patientDetails.insuranceType == 10) {
            insuranceDetails.overseasCover = patient.insurance;
            insuranceDetails.membershipNo = patient.membershipNo;
            insuranceDetails.membershipRefNo = patient.membershipRefNo;
            if(patient.insuranceId != 0) {
                insuranceDetails.insuranceFund = $insuranceFund.find(
                    (fund) => fund.id == patient.insuranceId,
                );
            } else {
                //default overseas fund selected
                insuranceDetails.insuranceFund = defaultOverseasFund;
            }
            
        } else if (patientDetails.insuranceType == 16) {
            if (!wcData) {
                const tempArr = patientDetails.insurance
                    .replaceAll(" ", "")
                    .split("|");

                if (tempArr.length == 4) {
                    insuranceDetails.employer = tempArr[2];
                    insuranceDetails.employerEmail = tempArr[3];
                    workerCompensationObj.insurerEmail = "";
                } else if (tempArr.length == 3) {
                    insuranceDetails.employer = tempArr[0];
                    insuranceDetails.employerEmail = tempArr[1];
                    workerCompensationObj.claimNumber = tempArr[2];
                }
            } else {
                const { employer, employerEmail, claimId, email } = wcData;

                insuranceDetails.employer = employer ?? "";
                insuranceDetails.employerEmail = employerEmail ?? "";
                workerCompensationObj.insurerEmail = email ?? "";
                workerCompensationObj.claimNumber = claimId ?? "";
            }
            // const tempArr = patientDetails.insurance
            //     .replaceAll(" ", "")
            //     .split("|");

            // if (tempArr.length == 4) {
            //     if (!wcData) {
            // insuranceDetails.employer = tempArr[2];
            // insuranceDetails.employerEmail = tempArr[3];
            //     } else {
            //         const { employer, employerEmail } = wcData;

            //         insuranceDetails.employer = employer
            //             ? employer
            //             : tempArr[2];
            //         insuranceDetails.employerEmail = employerEmail
            //             ? employerEmail
            //             : tempArr[3];
            //     }

            //     workerCompensationObj.insurerEmail = "";
            // } else if (tempArr.length == 3) {
            //     if (!wcData) {
            // insuranceDetails.employer = tempArr[0];
            // insuranceDetails.employerEmail = tempArr[1];
            //     } else {
            //         const { employer, employerEmail, claimId } = wcData;

            //         insuranceDetails.employer = employer
            //             ? employer
            //             : tempArr[0];
            //         insuranceDetails.employerEmail = employerEmail
            //             ? employerEmail
            //             : tempArr[1];
            //         workerCompensationObj.claimNumber = claimId ? claimId : tempArr[2];
            //     }

            //     workerCompensationObj.claimNumber = tempArr[2];
            // }

            // workerCompensationObj.insurerEmail = wcData?.email ?? "";
        } else if (patientDetails.insuranceType == 17) {
            // insuranceDetails.trafficAccidentClaimNumber = patient.insurance;
            trafficAuthorityObj.claimNumber = patient.insurance;
        } else if (patientDetails.insuranceType == 18) {
            thirdPartyPayerObj = {
                ...patientEncounterDetails.patientEncounterThirdPartyInsurerData,
            };
        } else if (patientDetails.insuranceType == 20) {
            // if (patientDetails.insurance)
            //     patientDetails.veteranNo = patient.insurance;
        } else if (
            patientDetails.insuranceType === DirectInsuranceType.DefenceBupa ||
            patientDetails.insuranceType == DirectInsuranceType.DefenceAMA
        ) {
            //if defence data object exists, use it
            if(patientEncounterDetails.patientEncounterDefenceData){
                defenceDataObj = {
                    ...patientEncounterDetails.patientEncounterDefenceData
                };
            }
            else {
                //otherwise, for encounters comiing via OCR, take them from patient details
                const pid = getPID(
                    patientDetails,
                    patientEncounterDetails,
                );
                const dan = getDAN(
                    patientDetails,
                    patientEncounterDetails,
                );
                defenceDataObj = {
                    pid, dan
                };
            }
        } else if (patientDetails.insuranceType == 30) {
            publicInPrivateObj = {
                ...patientEncounterDetails.patientEncounterPIPData,
            };
        }
    };

    const _updatePatientInsuranceDetails = () => {
        const { insuranceType } = patientDetails;

        // if (patientDetails.insurance) delete patientDetails.insurance;
        // if (patientDetails.insuranceId) delete patientDetails.insuranceId;
        // if (patientDetails.membershipNo) delete patientDetails.membershipNo;
        // if (patientDetails.membershipRefNo)
        //     delete patientDetails.membershipRefNo;

        switch (insuranceType) {
            case 0: // Private
                if (insuranceDetails.insuranceFund)
                    patientDetails.insuranceId =
                        insuranceDetails.insuranceFund.id;
                else delete patientDetails.insuranceId;
                patientDetails.membershipNo = insuranceDetails.membershipNo;
                patientDetails.membershipRefNo =
                    insuranceDetails.membershipRefNo
                        ? Number(insuranceDetails.membershipRefNo)
                        : null;
                if (insuranceDetails.privateCoverType)
                    patientDetails.insurance =
                        insuranceDetails.privateCoverType;
                break;
            case 10: // Overseas cover
                patientDetails.insurance = insuranceDetails.overseasCover;
                patientDetails.membershipNo = insuranceDetails.membershipNo;
                patientDetails.membershipRefNo =
                    insuranceDetails.membershipRefNo
                        ? Number(insuranceDetails.membershipRefNo)
                        : null;
                if (insuranceDetails.insuranceFund)
                    patientDetails.insuranceId =
                        insuranceDetails.insuranceFund.id;
                break;
            case 11: // Self insured
            case 15: // Cosmetic
            case 18: // Third Party Payer
                break;
            case 16: // Workers Comp
                patientDetails.insurance = `${
                    insuranceDetails.employer || ""
                } | ${insuranceDetails.employerEmail || ""} | ${
                    workerCompensationObj.claimNumber || ""
                }`;

                if (insuranceDetails.employer && workerCompensation)
                    workerCompensation.employer = insuranceDetails.employer;

                if (insuranceDetails.employerEmail && workerCompensation)
                    workerCompensation.employerEmail =
                        insuranceDetails.employerEmail;
                break;
            case 17: // Traffic accident
                patientDetails.insurance = `${trafficAuthorityObj.claimNumber ? trafficAuthorityObj.claimNumber : ""}`;
                break;
            case 20: // DVA
                patientDetails.insurance = `${insuranceDetails.dvaNumber}`;
                break;
            case 25: // Defence BUPA
            case 26: // Defence AMA
                patientDetails.insurance = `${defenceDataObj.pid ?? insuranceDetails.pidNumber ?? ""} | ${defenceDataObj.dan ?? insuranceDetails.danNumber ?? ""}`;
                break;
            case 30: // Public in Private
                patientDetails.insurance = `${
                    publicInPrivateObj.email ?? ""
                } | ${publicInPrivateObj.vendorNumbers ?? ""}`;
                break;
            default:
                break;
        }
    };

    const _updatePatientEncounterDetails = (patientDetails) => {
        patientEncounterDetails = {
            ...patientEncounterDetails,
            //update billing status if insurance type changed
            billingStatus: updatedBillingStatus(patientEncounterDetails.billingStatus, oldInsuranceType, patientDetails.insuranceType) ?? patientEncounterDetails.billingStatus,
            patient: { ...patientDetails },
            doctor: { id: $loggedInDoctorDetail.id },
            surgeon: !selectedSurgeon.details
                ? { id: 0 }
                : {
                      id: selectedSurgeon.details.id,
                      providerUniqueId:
                          selectedSurgeon.details.providerUniqueId,
                  },
            hospital: { id: selectedHospital.details?.id ?? 0 },
            doctorProvider: !selectedDoctorProvider.details
                ? null
                : { number: selectedDoctorProvider.details.number },
        };

        if (patientEncounterDetails.hospital.id == 0)
            patientEncounterDetails.hospitalId = 0;

        patientEncounterDetails = syncInsuranceDetailsOfLatestBillingData(
            patientEncounterDetails,
        );

        patientEncounterDetails = syncEncounterSpecialInsuranceObj(
            patientEncounterDetails,
            workerCompensation,
            workerCompensationObj,
            trafficAuthority,
            trafficAuthorityObj,
            publicInPrivateObj,
            thirdPartyPayerObj,
            defenceDataObj,
            insuranceDetails,
        );
    };

    const _updateScheduleDate = (scheduledDate) => {
        if (!scheduledDate) {
            delete patientEncounterDetails.scheduledDate;
            return;
        }

        const year = scheduledDate.split("-")[0];

        if (Number(year) < 1900) {
            delete patientEncounterDetails.scheduledDate;
            return;
        }

        const date = scheduledDate.split("T")[0];
        const time = scheduledDate.split("T")[1].slice(0, 5);

        patientEncounterDetails.scheduledDate = `${date}`;
        patientEncounterDetails.scheduledTime = `${time}`;
    };

    const _updateDischargeDate = (dischargeDate) => {
        if (!dischargeDate) return;

        const year = dischargeDate.split("-")[0];

        if (Number(year) < 1900) {
            delete patientEncounterDetails.dischargeDate;
            return;
        }

        const date = dischargeDate.split("T")[0];
        const time = dischargeDate.split("T")[1].slice(0, 5);

        patientEncounterDetails.dischargeDate = `${date}`;
        patientEncounterDetails.dischargeTime = `${time}`;
    };

    const _checkInputFieldsValid = async () => {
        errorFields = [];

        await _updateInvalidFieldsStyle();

        return errorFields.length == 0;
    };

    const _updateInvalidFieldsStyle = async () => {
        if (isEditDuplicate) await _checkDoctorProvider();

        const patientDetailsCheck =
            await patientSectionRef.checkPatientDetailsValidation();

        if (patientDetailsCheck.length)
            errorFields = [...errorFields, ...patientDetailsCheck];

        if(patientContactRef){
            const patientContactCheck =
                await patientContactRef.checkPatientContactValidation();

            if (patientContactCheck.length)
                errorFields = [...errorFields, ...patientContactCheck];
        }
       

        const procedureDetailsCheck =
            await procedureDetailsRef.checkProcedureDetailsValidation();

        if (procedureDetailsCheck.length)
            errorFields = [...errorFields, ...procedureDetailsCheck];

        const insuranceDetailsCheck =
            await insuranceDetailsRef.checkInsuranceDetailsValidation(
                patientDetails,
            );

        if (insuranceDetailsCheck.length)
            errorFields = [...errorFields, ...insuranceDetailsCheck];

        // const surgeonDetailsCheck =
        //     await surgeonDetailsRef.checkSurgeonDetailsValidation();

        // if (surgeonDetailsCheck.length)
        //     errorFields = [...errorFields, ...surgeonDetailsCheck];

        if (errorFields.length) {
            const scrollToElement = document.getElementById(errorFields[0]);
            if (scrollToElement)
                scrollToElement.scrollIntoView({ behavior: "smooth" });
        }
    };

    const _checkDoctorProvider = async () => {
        const doctorProviderContainer = document.getElementById(
            "doctorProviderContainer",
        );

        doctorProviderContainer.style.borderRadius = "5px";

        if (!isObjectEmpty(selectedDoctorProvider)) {
            errorFields = removeErrorInput(
                "doctorProviderContainer",
                errorFields,
            );

            doctorProviderContainer.style.outline = "";
            return;
        }

        if (!overrideValidation) {
            errorFields = addErrorInput("doctorProviderContainer", errorFields);

            doctorProviderContainer.style.outline = "red solid 2px";
        }
    };

    const _watchUnsavedDetails = (
        encounter,
        backupEncounter,
        patient,
        backupPatient,
        surgeon,
        backupSurgeon,
        hospital,
        backupHospital,
    ) => {
        if (isEditDuplicate) return;

        if (
            !encounter ||
            !backupEncounter ||
            isObjectEmpty(encounter) ||
            isObjectEmpty(backupEncounter)
        )
            return false;

        delete encounter.patient;
        delete backupEncounter.patient;
        if (patient.title == "Title") delete patient.title;
        delete surgeon.details?.isGroupItem;
        delete surgeon.details?.groupName;
        delete surgeon.details?.matchingId;
        delete backupSurgeon.details?.matchingId;
        if (surgeon.hasOwnProperty("matchingId")) delete surgeon.matchingId;
        if (backupSurgeon.hasOwnProperty("matchingId"))
            delete backupSurgeon.matchingId;
        delete hospital.details?.isGroupItem;
        delete hospital.details?.groupName;
        delete hospital.details?.groupItem;

        return (
            !areObjectEqual(encounter, backupEncounter) ||
            !areObjectEqual(patient, backupPatient) ||
            !areObjectEqual(surgeon, backupSurgeon) ||
            !areObjectEqual(hospital, backupHospital)
        );
    };

    const _checkIfEncounterEnablePartiallyEditOnly = (estimates, invoices) => {
        if (
            estimates &&
            estimates.length &&
            estimates.some((e) => e.status != 9)
        )
            return true;

        if (invoices && invoices.length && invoices.some((e) => e.status != 9))
            return true;

        return false;
    };

    const _checkIfEncounterHasActiveEstimateOrInvoice = (arr) =>
        arr && arr.length && arr.some((e) => e.status != 9);

    const _sumPayments = (arr) => {
        const activeArr = arr.filter((a) => a.status != 9);

        let res = 0;

        activeArr.map(({ payments }) => {
            if (!payments || !payments.length) return;

            res += payments.reduce((amt, payment) => {
                const { status, amount, processingFee } = payment;

                if (status == 1 || status == 2) amt += amount - processingFee;
                else if (status == 5) amt -= amount;

                return amt;
            }, 0);
        });

        return res;
    };

    const _syncNotificationMsg = (
        billingStatus,
        activeEstimate,
        activeInvoice,
    ) => {
        if (activeEstimate && (billingStatus == 1 || billingStatus == 2))
            return "Certain patient details cannot be changed after a quote has been submitted. To enable editing, please cancel the quote.";
        else if (activeInvoice) {
            if (billingStatus == 3)
                return "Certain patient details cannot be changed after and invoice has been submitted. To enable editing, please change the encounter status to Ready in the billing tab.";
            else if (billingStatus == 4 || billingStatus == 5)
                return "Certain patient details cannot be changed after an invoice has been submitted.";
            else
                return "Certain patient details cannot be changed after a quote or an invoice were submitted. To enable editing, please cancel the encounter estimates and invoices";
        } else
            return "Certain patient details cannot be changed after the encounter is submitted. To enable editing, please change the encounter billing status back to Ready.";
    };

    const _openOpvFailedModal = () => (isOpvFailedModalOpen = true);

    const _closeOpvFailedModal = () => (isOpvFailedModalOpen = false);

    const _openUnlockAllInputsModal = () => (unlockAllInputsModalOpen = true);

    const _closeUnlockAllInputsModal = () => (unlockAllInputsModalOpen = false);
</script>

{#if isLoading}
    <PageLoading />
{:else}
    <div class="flex-1 flex mt-4 w-full">
        <div class="flex flex-1 {isFromCalendarList ? 'relative' : ''}">
            <form
                class="flex flex-col flex-1 gap-y-4 overflow-y-auto {isFromCalendarList
                    ? 'absolute inset-0'
                    : ''}"
            >
                <div class="flex flex-1 w-full items-center justify-between">
                    <div
                        class="flex gap-x-2 items-center cursor-pointer"
                        on:click|preventDefault={() =>
                            ($EncounterSidePanelProps.type = "view")}
                    >
                        {#if isFromCalendarList}
                            <BackArrow backFunc={() => {}} />
                            <p class="text-[#6F726C]">View Encounter Details</p>
                        {/if}
                    </div>

                    <div class="flex items-center gap-x-2">
                        {#if showSaveWithoutValidations}
                            <Button
                                clickFunc={() => {
                                    overrideValidation = true;
                                    handleUpdateEncounter();
                                }}
                                isDisabled={isUpdatingPatientEncounter ||
                                    isCheckingOPV}
                                defaultClass="btn btn-sm btn-error text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                                manualClass={isUpdatingPatientEncounter
                                    ? "loading"
                                    : ""}
                            >
                                {isUpdatingPatientEncounter ? "Saving" : "Save with invalid fields"}
                            </Button>
                        {/if}
                        <Button
                            clickFunc={() => {
                                overrideValidation = false;
                                handleUpdateEncounter();
                            }}
                            isDisabled={isUpdatingPatientEncounter ||
                                isCheckingOPV}
                            defaultClass="btn btn-sm btn-secondary text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                            manualClass={isUpdatingPatientEncounter
                                ? "loading"
                                : ""}
                        >
                            {isUpdatingPatientEncounter ? "Saving" : "Save"}
                        </Button>

                     </div>
                </div>

                {#if isEncounterEnablePartiallyEditOnly && !UNLOCK_ALL_INPUTS}
                    <div
                        class="flex flex-1 w-full border-rose-600 text-white bg-rose-600 border-2 rounded-lg p-2 gap-x-2"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            class="stroke-white shrink-0 w-6 h-6"
                            ><path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path></svg
                        >
                     
                        
                        <div class="flex-1 flex flex-row justify-between">
                            <p class="bg-rose-600 cursor-default">
                                {lockInputNotificationMsg}
                            </p>
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <!-- svelte-ignore a11y-no-static-element-interactions -->
                            <div on:click={_openUnlockAllInputsModal} class="pl-4 font-bold text-sm pr-4 bg-white text-rose-600 rounded-md hover:bg-secondary hover:text-white cursor-pointer flex items-center justify-center">
                                Unlock all fields
                            </div>
                        </div>
                      
                    </div>
                {/if}

                {#if enableChangeEncounterDoctor}
                    <ChangeDoctorSection
                        {patientSectionRef}
                        {procedureDetailsRef}
                        {insuranceDetailsRef}
                    />
                {/if}

                <PatientDetailsSection
                    bind:this={patientSectionRef}
                    bind:patientDetails
                    bind:isPatientMatched
                    {isEditDuplicate}
                    {disableInputScenario_ONE}
                    {disableInputScenario_TWO}
                    {UNLOCK_ALL_INPUTS}
                    {overrideValidation}
                    {enableChangeEncounterDoctor}
                />

                <ProcedureDetailsSection
                    bind:this={procedureDetailsRef}
                    bind:selectedSurgeon
                    bind:selectedHospital
                    bind:createSurgeonFilters
                    bind:patientEncounterDetails
                    on:onHospitalChange={onHospitalChange}
                    typeOfBill={patientEncounterDetails.typeOfBill}
                    {isEncounterHasActiveInvoice}
                    {disableInputScenario_TWO}
                    {UNLOCK_ALL_INPUTS}
                    {overrideValidation}
                    {insuranceDetailsRef}
                    on:encounterTypeChange={() =>
                        (patientDetails =
                            syncLabourEpiduralPatientTitleAndGender(
                                patientEncounterDetails,
                                patientDetails,
                            ))}
                />

                <InsuranceDetailsSection
                    bind:this={insuranceDetailsRef}
                    bind:patientDetails
                    bind:patientEncounterDetails
                    bind:insuranceDetails
                    bind:workerCompensation
                    bind:workerCompensationObj
                    bind:trafficAuthority
                    bind:trafficAuthorityObj
                    bind:publicInPrivateObj
                    bind:thirdPartyPayerObj
                    bind:defenceDataObj
                    bind:selectedDoctorProvider
                    bind:createSurgeonFilters
                    {selectedHospital}
                    {disableInputScenario_ONE}
                    {disableInputScenario_TWO}
                    hasReceivedPayments={totalSumOfPayments > 0}
                    {isEncounterEnablePartiallyEditOnly}
                    {UNLOCK_ALL_INPUTS}
                    {overrideValidation}
                />

                <CardLayout title="Optional fields" cardClass="p-1 pb-4" enableCollapse={true} defaultExpanded={false}>

                    <PreOpDetailsSection
                        isFromCreate
                        bind:patientEncounterDetails
                    />

                    <!-- <PatientContactSection
                        bind:this={patientContactRef}
                        bind:patientContactDetails
                        bind:patientEncounterDetails
                        {overrideValidation}
                    /> NOT NEEDED ON EDIT, BECAUSE CONTACTS CAN BE ADDED FROM WITHIN THE ENCOUNTER--> 

                    <OtherDetailsSection
                        bind:patientEncounterDetails
                        bind:patientDetails
                        {overrideValidation}
                    />

                </CardLayout>

                <div class="flex flex-row gap-x-2">
                    <Button
                        clickFunc={handleUpdateEncounter}
                        isDisabled={isUpdatingPatientEncounter}
                        defaultClass="btn btn-sm btn-secondary text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                        manualClass={isUpdatingPatientEncounter ? "loading" : ""}
                    >
                        {isUpdatingPatientEncounter ? "Saving" : "Save"}
                    </Button>
                    {#if showSaveWithoutValidations}
                        <Button
                            clickFunc={() => {
                                overrideValidation = true;
                                handleUpdateEncounter();
                            }}
                            isDisabled={isUpdatingPatientEncounter ||
                                isCheckingOPV}
                            defaultClass="btn btn-sm btn-error text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                            manualClass={isUpdatingPatientEncounter
                                ? "loading"
                                : ""}
                        >
                            {isUpdatingPatientEncounter ? "Saving" : "Save with invalid fields"}
                        </Button>
                    {/if}
                </div>
               
            </form>
        </div>
    </div>
{/if}

<div
    class={isShowConfirmModalAfterAttempt
        ? "modal modal-open sm:modal-middle"
        : "modal"}
>
    <div class="modal-box">
        <h3 class="font-medium text-lg">
            OPV failed for patient. Save anyway?
        </h3>
        <div class="modal-action flex justify-center gap-x-4">
            <button
                class="btn btn-error text-white btn-sm border-none w-24"
                on:click={closeConfirmModalAfterAttempt}
            >
                Cancel
            </button>
            <button
                class="btn btn-secondary text-white btn-sm border-none w-24"
                on:click={() => updateProcess(patientDetails)}
            >
                Save
            </button>
        </div>
    </div>
</div>

{#if isCheckingOPV}
    <LoadingModal titleText="Checking OPV..." />
{/if}

<NotificationModal
    title="OPV Failed"
    isModalOpen={isOpvFailedModalOpen}
    showConfirmBtn={false}
    closeModal={_closeOpvFailedModal}
    closeModalFunction={_closeOpvFailedModal}
>
    <div class="flex flex-1 flex-col gap-y-4">
        <p class="text-lg">
            Patient verification failed. Please check the information and try
            again.
        </p>
        <p class="text-lg">
            The information will not be saved if OPV does not pass.
        </p>
        <div class="flex flex-1 flex-col gap-y-2">
            {#each Object.entries(opvResponse) as [key, value]}
                {#if /suggested/.test(key) && value}
                    <p>
                        {splitCamelCase(key)}: {(value ?? value) ? value : ""}
                    </p>
                {/if}
            {/each}
        </div>
    </div>
</NotificationModal>

<NotificationModal
    title="Unlock fields"
    isModalOpen={unlockAllInputsModalOpen}
    cancelText="Cancel"
    closeModal={_closeUnlockAllInputsModal}
    submitText="Unlock"
    confirmAction={handleUnlockAllInputs}
    closeModalFunction={_closeUnlockAllInputsModal}
>
    <p class="text-error">
        Are you sure that you want to edit the locked fields?
    </p>
    <p class="text-error">
        This may mean that the quote or invoice that has been sent out provides
        incorrect information such as insurance rebates.
    </p>
</NotificationModal>

<NotificationModal
    title="Important"
    isModalOpen={showKeyInsuranceEditedModal}
    showCancelBtn={false}
    submitText="Done"
    confirmAction={closesKeyInsuranceEditedModal}
    closeModalFunction={closesKeyInsuranceEditedModal}
>
    <div class="flex flex-col gap-y-4">
        <div class="leading-6 text-md">
            The encounter quotes and invoices were cancelled due to the changes
            made.
        </div>
        <div class="leading-6 text-md">Please make sure to:</div>
        <div class="leading-6 text-md font-medium">
            1. Re-apply the billing rule to get the correct rebates
        </div>
        <div class="leading-6 text-md font-medium">
            2. Re-create the quote and invoice (if necessary)
        </div>
        <div class="leading-6 text-md font-medium">
            3. Move any payments received to the new quote or invoice
        </div>
    </div>
</NotificationModal>

<style>
    i {
        font-size: 20px;
    }
</style>
